const namespace = {
  title: "Highlights",
  noData:
    "Discover what this neighborhood has to offer in terms of transportation, services, and character.",
  highlight: {
    title: "This area is great for",
  },
} as const;

export default namespace;
